import React from 'react';
import { Row, Col, Typography, Card, Button, Layout, Icon } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import eventIcon from '../../../../assets/img/event.png';
import VettingCalendar from '../../../UI_V2_Components/shared/VettingCalendar/VettingCalendar';

const { Title, Text } = Typography;

export const addCalendlyScript = (id) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.id = `calendly-${id}`;
    script.onload = () => resolve(true);
    script.onerror = (error) => reject(error);
    document.body.appendChild(script);
  });
};

export const addCalendlyCSSFile = (id) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.id = `calendly-css-${id}`;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.onerror = (error) => reject(error);
    document.body.appendChild(link);
    resolve(true);
  });
};

export const removeCalendlyScript = (id) => {
  const script = `calendly-${id}`;
  const calendlyWidget = document.getElementById('calendly');
  // Checks if the script is added in the first place
  // before attempting to remove it
  if (document.getElementById(script)) {
    document.getElementById(script).remove();
  } else if (calendlyWidget) {
    calendlyWidget.remove();
  }
};

export const removeCalendlyCSSFile = (id) => {
  const script = `calendly-css-${id}`;
  const calendlyWidget = document.getElementById('calendly');
  if (document.getElementById(script)) {
    document.getElementById(script).remove();
  } else if (calendlyWidget) {
    calendlyWidget.remove();
  }
};

export const initializeCalendly = (fullName, email, calendarUrl, id) => {
  /** Use timeout to delay this function pending when script is added to the component head */
  const script = `calendly-${id}`;
  setTimeout(() => {
    if (document.getElementById(script) && document.getElementById('calendly')) {
      Calendly.initInlineWidget({ // eslint-disable-line
        url: calendarUrl,
        parentElement: document.getElementById('calendly'),
        prefill: {
          name: fullName,
          email: email
        },
        utm: {}
      });
    }
  }, 2000);
};

export const isCalendlyEvent = (e) => {
  if (e.origin.startsWith('https://calendly.com')) {
    return e.data.event &&
      e.data.event.indexOf('calendly') === 0;
  }
};

export const openMeetingLink = (link) => {
  window.open(link);
};

const RenderPageComponent = React.memo((props) => {
  if (props.checkValidMsg) {
    return <Layout><CheckValidMsgBox {...props} /></Layout>;
  }

  if (props.checkDone && props.eventDetails.developer_id) {
    return <Layout><ConfirmedCard {...props} /></Layout>;
  }

  return (
    <Layout>
      {!props.impersonate && <CalendlyInlineWidget useCalendly={props.useCalendly} />}
    </Layout>
  );
});

RenderPageComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  titleA: PropTypes.string,
  textA: PropTypes.string,
  titleB: PropTypes.string,
  details: PropTypes.oneOfType([
    PropTypes.string, PropTypes.object
  ]),
  eventDetails: PropTypes.object,
  confirmationText: PropTypes.string,
  callInfoText: PropTypes.string,
  calendarText: PropTypes.string,
  checkDone: PropTypes.bool,
  checkValidMsg: PropTypes.bool,
  validMsgText: PropTypes.string,
  impersonate: PropTypes.bool,
  useCalendly: PropTypes.bool
};

const CalendlyInlineWidget = React.memo((props) => {
  if (props.useCalendly) {
    return <div id="calendly" className="calendly-inline-widget" style={{ minWidth: '320px', height: '717px' }} data-auto-load="false" />;
  }

  return <VettingCalendar calId={1} />;
  // return <div id="calendly" className="calendly-inline-widget" style={{ minWidth: '320px', height: '717px' }} data-auto-load="false" />;
});

CalendlyInlineWidget.propTypes = {
  useCalendly: PropTypes.bool
};

const CheckValidMsgBox = React.memo((props) => {
  return (
    <div className={props.classes.checkValidMsg}>
      <p>{props.validMsgText}</p>
      <Icon type="lock" style={{ fontSize: '55px', paddingTop: '25px' }} />
    </div>
  );
});

CheckValidMsgBox.propTypes = {
  classes: PropTypes.object.isRequired,
  validMsgText: PropTypes.string
};

const ConfirmedCard = React.memo((props) => {
  return (
    <Card className={props.classes.card} style={{ maxWidth: 500 }}>
      <Row>
        <Col>
          <Text className={props.classes.confirmed}>Confirmed</Text><br />
        </Col>
        <Col>
          <Title level={4} className={props.classes.titleA}>{props.confirmationText}</Title>
        </Col>
        <Col>
          <Row type="flex" justify="space-between" align="bottom">
            <Col span={15}>
              {props.eventDetails.meeting_id ? (
                <div>
                  <Text className={props.classes.confirmedText}>{moment(props.eventDetails.event_date).format('dddd, MMMM DD, YYYY')}</Text><br />
                  <Text className={props.classes.confirmedText}>{moment(props.eventDetails.event_start_time).format('hh:mm A')} - {moment(props.eventDetails.event_end_time).format('hh:mm A')} (UTC{moment(props.eventDetails.eventDate).format('Z')})</Text>
                </div>
              ) : (
                <Text>{props.callInfoText}</Text>
              )}
            </Col>
            <Col>
              <img src={eventIcon} alt="icon" className={props.classes.eventIcon} />
            </Col>
          </Row>
        </Col>
        <Col>
          <br />
          { props.eventDetails.meeting_link ? (
            <Button icon="link" className={props.classes.interviewLink} onClick={() => openMeetingLink(props.eventDetails.meeting_link)}>Interview link</Button>
          ) : (
            <Text style={{ wordBreak: 'break-word' }}>{props.calendarText}</Text>
          )}
        </Col>
      </Row>
    </Card>
  );
});

ConfirmedCard.propTypes = {
  classes: PropTypes.object.isRequired,
  eventDetails: PropTypes.object,
  confirmationText: PropTypes.string,
  callInfoText: PropTypes.string,
  calendarText: PropTypes.string
};

export default RenderPageComponent;
